import React, { useEffect, useState } from 'react';
import './Toast.css';

export interface ToastMessage {
  id: string;
  type: 'info' | 'success' | 'warning' | 'error';
  title: string;
  message: string;
  action?: {
    label: string;
    onClick: () => void;
  };
  duration?: number; // ms, 0 = no auto-dismiss
}

interface ToastProps {
  message: ToastMessage;
  onDismiss: (id: string) => void;
}

const Toast: React.FC<ToastProps> = ({ message, onDismiss }) => {
  const [isExiting, setIsExiting] = useState(false);

  useEffect(() => {
    if (message.duration !== 0) {
      const timer = setTimeout(() => {
        handleDismiss();
      }, message.duration || 5000);

      return () => clearTimeout(timer);
    }
  }, [message]);

  const handleDismiss = () => {
    setIsExiting(true);
    setTimeout(() => {
      onDismiss(message.id);
    }, 300);
  };

  const getIcon = () => {
    switch (message.type) {
      case 'success':
        return '✅';
      case 'warning':
        return '⚠️';
      case 'error':
        return '❌';
      case 'info':
      default:
        return '🔔';
    }
  };

  return (
    <div className={`toast toast-${message.type} ${isExiting ? 'toast-exit' : ''}`}>
      <div className="toast-icon">{getIcon()}</div>
      <div className="toast-content">
        <div className="toast-title">{message.title}</div>
        <div className="toast-message">{message.message}</div>
      </div>
      {message.action && (
        <button
          className="toast-action"
          onClick={() => {
            message.action!.onClick();
            handleDismiss();
          }}
        >
          {message.action.label}
        </button>
      )}
      <button className="toast-dismiss" onClick={handleDismiss}>
        ×
      </button>
    </div>
  );
};

export default Toast;

